import { extractCnjLawsuitNumber } from '../extract-cnj-lawsuit-number/extract-cnj-lawsuit-number'

export const hasValidLawsuitNumber = (term: string | undefined): boolean =>
  !!(term && extractCnjLawsuitNumber(term))
